import { dataExportApi } from '@/core/api/data-export'

export const {
  useLazyExportConsultationsQuery,
  useLazyExportPatientsQuery,
  useLazyExportMedicalActsQuery,
  useLazyExportMesuresQuery,
  useLazyExportPregnanciesQuery,
} = dataExportApi
